import React, {Component} from 'react';

export default class MapPin extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showModal: false }
  }

  render() {
    return(
      <div
        className="App-mapPin"
        onClick={() => {
          this.props.onClick(this.props.data);
          this.setState({showOverlay: true});
        }}

        onMouseEnter={() => {this.setState({showModal: true})}}
        onMouseLeave={() => {this.setState({showModal: false})}}
      >
        {/* {this.props.data.location} */}

        {this.state.showModal &&
        <div><span className="mapPin-location">{ this.props.data.location }</span><a href={ this.props.data.effectUrl } className="mapPin-effecturl">🤓 View AR Effect</a></div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mapPin.js